<style lang="less" scoped>
	.form-control {
		.optionpadd {
			p {
				display: block;
				line-height: 30px !important;
				height: 30px !important;
				margin: 5px auto !important;
			}
		}
	}

	/deep/ .el-radio-group {
		display: flex;

		label {
			border: none !important;
		}
	}


	div {
		color: #333;
	}

	/deep/ .el-tag {
		background-color: #1CAF9A !important;
		color: #fff;
	}

	/deep/ .el-tag .el-tag__close {
		color: #fff;
	}


	.addinput {
		background: #fff;
		padding: 1rem;

		.addinputtop {
			width: 100%;
			height: 4rem;
			background: #fff;
			border-left: 4px solid #14C856;
			padding: 0.7rem 0 0 1rem;
			margin-bottom: 1rem;
			box-sizing: border-box;

			p:first-child {
				font-size: 1.2rem;
				color: #333;

			}

			p:last-child {
				font-size: 0.8rem;
				color: #77818e;

			}
		}

		.addform {
			display: flex;
			justify-content: center;
			flex-direction: column;

			label:last-child {
				border-bottom: 1px solid #ccc;
			}

			label,
			.labelas {
				textarea {
					color: #333;
				}

				display: block;
				width: 100%;
				padding: 1rem 0;
				border-top: 1px solid #ccc;
				box-sizing: border-box;

				.labelchiles {
					margin: 0 auto;
					display: flex;
					align-items: center;

					p {
						// width: 5vw;
						text-align: right;
						margin-right: 1rem;
						color: rgb(74, 83, 94);
						font-size: 0.8rem;
					}
				}
			}

		}

		.fromsbtn {
			// width: 50%;
			margin: 1rem auto;
			display: flex;
			align-items: center;
			justify-content: center;


			button {
				margin: 0 1rem;
				padding: 0.6rem 2rem;
				border-radius: 2px;
				background-color: #F7F7F7;
				color: #333;
				border: 1px solid #ccc;
			}

			button:first-child {
				background-color: #3071A9;
				color: #fff;
			}

			button:hover {
				background-color: #1f92ea;
			}

			button:last-child:hover {
				background-color: #d9d9d9;
			}


		}

	}


	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	}
</style>


<template>
	<div>
		<titles titlename="增加设备电源" titlecontent="增加设备电源" :mbx="paths"></titles>
		<div class="addinput">
			<div class="addinputtop">
				<p>增加设备电源</p>
				<p>将电源设备连接到云端</p>
			</div>
			<form class="addform">
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">电源设备名称<span style="color: red;">*</span></p>
						<input maxlength="20" v-model="powerobj.sx_tp_name" type="text" class="form-control" placeholder="请输入电源设备名称">
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">电源设备编号<span style="color: red;">*</span></p>
						<input maxlength="20" v-model="powerobj.sx_tp_number" type="text" class="form-control" placeholder="请输入电源设备编号">
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">所属院校<span style="color: red;">*</span></p>
						<select @change="chosedDtrain" v-model="powerobj.si_guid"
							class="form-control  div-select-target" id="exampleFormControlSelect1">
							<option value="" class="optionpadd">
								<p>-- 请选择所属院校 --</p>
							</option>
							<option class="optionpadd" v-for="(item,index) in schoollist" :key="index"
								:label="item.si_name_cn" :value="item.si_guid">

								<p>{{item.si_name_cn}}</p>
							</option>
						</select>
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">所属实训室<span style="color: red;">*</span></p>
						<select v-model="powerobj.sx_tr_guid" class="form-control" id="exampleFormControlSelect1"
							placeholder="请选择实训室" @change="chosedDtraintrin">
							<option value="">-- 请选择实训室 --</option>
							<option v-for="(item,index) in trainlist" :key="index" :value="item.sx_tr_guid">
								<p>{{item.tr_name}}</p>
							</option>
						</select>
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">所属实训设备<span style="color: red;">*</span></p>
						<select v-model="powerobj.sx_te_guid" class="form-control" id="exampleFormControlSelect1">
							<option value="">
								-- 请选择所属实训设备 --
							</option>
							<option v-for="(item,index) in trainsblist" :key="index" :lable="item.sx_te_guid"
								:value="item.sx_te_guid">
								<p>{{item.te_deviceName}}</p>
							</option>
						</select>
					</div>
				</label>
				<!-- <label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">电源状态</p>
						<el-radio-group v-model="powerobj.sx_tp_state">
							<el-radio label="1">
								开启
							</el-radio>
							<el-radio label="-1">
								关闭
							</el-radio>
						</el-radio-group>
					</div>
				</label> -->
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">电源设备位置</p>
						<input v-model="powerobj.sx_tp_position" type="text" class="form-control"
							placeholder="请输入电源设备位置">
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">设备MAC地址</p>
						<input @input="macchanges()" v-model="powerobj.sx_tp_mac" type="text" class="form-control"
							placeholder="请输入设备MAC地址" maxlength="17"
							:style="{'border-color':ismacshow?'red':'','box-shadow': ismacshow?'1px 1px 1px red':''}">
						<span v-if="ismacshow" style="color: red;margin-left: 0.4rem;font-size: 0.6vw;">
							请输入正确的mac地址
						</span>
					</div>
				</label>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">设备ip地址</p>
						<input @input="ipchanges()" v-model="powerobj.sx_tp_ip" type="text" class="form-control"
							placeholder="请输入设备id地址" maxlength="17"
							:style="{'border-color':isipshow?'red':'','box-shadow': isipshow?'1px 1px 1px red':''}">
						<span v-if="isipshow" style="color: red;margin-left: 0.4rem;font-size: 0.6vw;">
							请输入正确的ip地址
						</span>
					</div>
				</label>
				<div class="labelas">
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">上传图片（可选）</p>
						<upload :filelist="filelist"></upload>
					</div>
				</div>
				<div class="labelas">
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">标签（tags）</p>
						<el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false"
							@close="handleClose(tag)">
							{{tag}}
						</el-tag>
						<div style="width: 10vw;">
							<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
								size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
							</el-input>
							<button v-else size="small" class="button-new-tag" @click="showInput">新增</button>
						</div>
					</div>
				</div>
				<label>
					<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
						<p class="col-xs-4 col-sm-4 col-md-4 col-lg-2">描述</p>
						<textarea v-model="powerobj.sx_tp_remarke" class="form-control" rows="10"></textarea>
					</div>
				</label>
			</form>
			<div class="fromsbtn col-xs-12 col-sm-10 col-md-8 col-lg-8">
				<button @click="pmentInsert()" v-preventReClick>提交</button>
				<button>取消</button>
			</div>
		</div>
	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	import upload from "@/components/upload/uploadpower.vue"
	import {
		GetTrainPowerSingle,
		GetbfyTrainEquipmentLists,
		GetTrainEquipmentInsert,
		GetTrainPowerInsertOrEdit,
		getbfyGetTrainList,
		getTrainEquipmentList
	} from "@/request/api/trainroom/trainroom.js"
	import {
		GetbjGetSchoolList,
	} from "@/request/api/mange/mange.js"
	
	import AppOptions from '@/config/AppOptions.vue';
	
	export default {
		components: {
			titles,
			upload
		},
		data() {
			return {
				ismacshow: false,
				isipshow: false,
				// 院校不分页
				schoollist: [],
				trainlist: [],
				// 标题组件
				paths: [{
						path: "/device/sourcemange",
						name: "实训管理"
					},
					{
						path: "/device/addsourcemange",
						name: "增加设备电源"
					}
				],
				// tag组件
				dynamicTags: [],
				inputVisible: false,
				inputValue: '',
				// 单个电源设备
				powerobj: {
					sx_te_guid: "",
					si_guid: "",
					sx_tr_guid: "",
					sx_tp_position: "",
					sx_tp_remarke: ""

				},
				trainsblist: [],
				sxtppicUrl: {},
				filelist: []

			}
		},
		created() {
			AppOptions.appEmpty = false;
		},
		beforeMount() {
			this.powerobj.si_guid = this.$route.query.siguid ?? ""
			this.powerobj.sx_tr_guid = this.$route.query.sx_tr_guid ?? ""

			GetbjGetSchoolList().then(res => {
				console.log(res, "院校不分页")
				this.schoollist = res.data.data

			})
			if (this.powerobj.si_guid !== '') {

				this.getmangeslist(this.powerobj.si_guid)
				this.chosedDtrainsb()
			} else {
				this.powerobj.sx_tr_guid = ""
			}
		},

		mounted() {

			// .$refs.upload
		},
		updated() {

		},
		methods: {
			macchanges() {
				var reg_name = /[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}/
				var reg_name1 = /[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}-[A-F\d]{2}/
				if (reg_name.test(this.powerobj.sx_tp_mac) || reg_name1.test(this.powerobj.sx_tp_mac)) {
					this.ismacshow = false
					console.log("进入正确",reg_name1.test(this.powerobj.sx_tp_mac))
				} else {
					this.ismacshow = true
					console.log("进入正确",reg_name1.test(this.powerobj.sx_tp_mac))
				}
			},
			ipchanges() {
				var reg_name = /^((?:(?:25[0-5]|2[0-4]\d|[01]?\d?\d)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d?\d))$/
				if (!reg_name.test(this.powerobj.sx_tp_ip)) {
					this.isipshow = true
				} else {
					this.isipshow = false
				}
			},
			// 获取实训室
			getmangeslist(ifs) {
				console.log(ifs)
				getbfyGetTrainList(ifs).then(res => {
					console.log(res, "实训室不分页")
					this.trainlist = res.data.data
				})
			},

			getmanges(ifs) {
				// console.log(ifs)
				getbfyGetTrainList(ifs).then(res => {
					console.log(res, "实训室不分页")
					this.trainlist = res.data.data
				})

				this.chosedDtrainsb()

			},
			// 更改学校获取实训室
			chosedDtrain() {
				console.log(this.powerobj.si_guid)
				
				this.getmanges(this.powerobj.si_guid)
				this.powerobj.sx_te_guid = ""
				this.powerobj.sx_tr_guid = ""
			},
			// 更改实训室获取实训设备
			chosedDtraintrin() {
				this.chosedDtrainsb()
				if (this.powerobj.sx_tr_guid == "") {
					this.powerobj.sx_te_guid = ""
				}
			},
			chosedDtrainsb() {
				let dtrainobj = {
					sx_tr_guid: this.powerobj.sx_tr_guid,
					te_deviceName: "",
					si_guid:this.powerobj.si_guid
				}
				getTrainEquipmentList(dtrainobj).then(res => {
					console.log(res, "设备不分页")
					this.trainsblist = res.data.data
				})

			},


			// save电源
			pmentInsert() {
				if(this.ismacshow || this.isipshow){
					return 
				}
				
				
				this.sxtppicUrl = this.$store.state.trainimg
				// console.log(this.powerobj.sx_tp_state)
				let insertobj = {
					sx_tp_guid: this.$route.query.sx_tp_guid ?? "",
					sx_tp_name: this.powerobj.sx_tp_name,
					sx_tp_number: this.powerobj.sx_tp_number,
					sx_tp_tags: this.dynamicTags.join("#"),
					sx_tp_remarke: this.powerobj.sx_tp_remarke,
					sx_tp_state: 1,
					sx_te_guid: this.powerobj.sx_te_guid,
					filename: this.powerobj.sx_tp_picUrl ?? this.sxtppicUrl,
					sx_tp_position: this.powerobj.sx_tp_position,
					sx_tp_mac: this.powerobj.sx_tp_mac,
					sx_tp_ip: this.powerobj.sx_tp_ip
				}
				let from_data = new FormData()
				// console.log(insertobj)
				from_data.append("sx_tp_guid", insertobj.sx_tp_guid ?? '')
				from_data.append("sx_tp_name", insertobj.sx_tp_name ?? '')
				from_data.append("sx_tp_number", insertobj.sx_tp_number ?? '')
				from_data.append("sx_tp_tags", insertobj.sx_tp_tags ?? '')
				from_data.append("sx_tp_remarke", insertobj.sx_tp_remarke ?? '')
				from_data.append("sx_tp_state", insertobj.sx_tp_state ?? '')
				from_data.append("sx_te_guid", insertobj.sx_te_guid ?? '')
				from_data.append("filename", insertobj.filename ?? '')
				from_data.append("sx_tp_position", insertobj.sx_tp_position ?? '')
				from_data.append("sx_tp_mac", insertobj.sx_tp_mac ?? '')
				from_data.append("sx_tp_ip", insertobj.sx_tp_ip ?? '')
				
				if (this.powerobj.si_guid == '') {
					this.$message("学校不能为空")
				} else if (this.powerobj.sx_tr_guid == '') {
					this.$message("实训室不能为空")
				}else if (this.isipshow || this.ismacshow) {
					this.$message("请输入正确的ip与mac地址")
				} else {
					console.log(insertobj)

					GetTrainPowerInsertOrEdit(from_data).then(res => {
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你，' + res.data.msg,
								type: 'success'
							});

							this.dynamicTags = []
							this.filelist = []
							this.powerobj = {}
							this.powerobj.sx_te_guid = ""
							this.powerobj.si_guid = ""
							this.powerobj.sx_tr_guid = ""
							
						} else {
							this.$message(res.data.msg);
						}
					})
				}


			},
			// 标签
			handleClose(tag) {
				this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
			},

			showInput() {
				this.inputVisible = true;
				this.$nextTick(() => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.dynamicTags.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
			},
			opentag() {
				console.log(111)
			},
			deletag(i) {
				console.log(i)
				this.tags.splice(i, 1)
			}
		}
	}
</script>

<style>
</style>
